import { computed } from 'vue';
import { useWorkspaceAddAndEdit } from '@/dashboard/store/workspaceAddEditStore';
import { Step } from '@/dashboard/types/step';
import { useAppStore } from '@/dashboard/store/appStore';
import { storeToRefs } from 'pinia';
import { OwnerAdminRoles } from '@/dashboard/constants/roles';

export function useWorkspaceTeamSection() {
  const appStore = useAppStore();
  const workspaceAddAndEdit = useWorkspaceAddAndEdit();

  const { workspace, currentWorkspaceUser } = storeToRefs(appStore);
  const canAddUsers = computed(() => {
    const role = currentWorkspaceUser.value?.role;
    if (role) {
      return OwnerAdminRoles.includes(role) && workspace.value?.type === 'team';
    } else {
      return false;
    }
  });

  function addUser() {
    if (workspace.value) {
      workspaceAddAndEdit.openPopup(false, workspace.value, Step.Team);
    }
  }

  return { canAddUsers, currentWorkspaceUser, workspace, addUser };
}
